const patchedObjects = [];

class MonkeyPatch {
  // #if process.env.NODE_ENV === "test"
//   static resetAll() {
//     patchedObjects.forEach(({ obj, propertyName, dataKey, value }) => {
//       MonkeyPatch._applyPatch(obj, propertyName, { [dataKey]: value });
//     });
// 
//     // Clear the array.
//     patchedObjects.splice(0, patchedObjects.length);
//   }
  // #endif

  static _applyPatch(obj, propertyName, protoMap) {
    if (obj.propertyName !== undefined) {
      delete obj[propertyName];
    }

    try {
      // See
      // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/defineProperty#Description
      Object.defineProperty(obj, propertyName, protoMap);
    } catch (e) {
      // TODO(Austin): Delete added patchedObject entry?
      throw new Error(
        `Cannot monkey patch ${obj.constructor.name}[${propertyName}], because: '${e}'.`
      );
    }
  }

  static _patch(obj, propertyName, dataKey, value) {
    const originalValue = Object.getOwnPropertyDescriptor(obj, propertyName)[
      dataKey
    ];

    patchedObjects.push({
      obj,
      propertyName,
      dataKey,
      value: originalValue,
    });

    MonkeyPatch._applyPatch(obj, propertyName, { [dataKey]: value });
  }

  static patchFunction(obj, propertyName, fn) {
    // "value" is the property value. See doc in _applyPatch.
    MonkeyPatch._patch(obj, propertyName, "value", fn);
  }

  static patchSetter(obj, propertyName, fn) {
    // "set" is the property setter. See doc in _applyPatch.
    MonkeyPatch._patch(obj, propertyName, "set", fn);
  }

  static patchGetter(obj, propertyName, fn) {
    // "get" is the property getter. See doc in _applyPatch.
    MonkeyPatch._patch(obj, propertyName, "get", fn);
  }
}

export default MonkeyPatch;



// WEBPACK FOOTER //
// ./src/js/lib/monkey_patch.js